<template>
  <div class="home">
    <a-layout>

      <a-layout-header style="background: #001529; height: 20px;">
      </a-layout-header>

      <a-modal v-model="authModalVisible" :footer="null">
        <a-tabs default-active-key="1">
          <a-tab-pane key="1" tab="Sign up">
            <SignUp></SignUp>
          </a-tab-pane>
          <a-tab-pane key="2" tab="Login" force-render>
            <Login></Login>
          </a-tab-pane>
        </a-tabs>
      </a-modal>

      <a-modal v-model="aboutModalVisible" :footer="null">
        <About></About>
      </a-modal>      

      <a-layout-content 
        class="content" 
        style="background: #fff; padding-top: 100px;"
      >
        <img 
          class="logo" 
          src="@/assets/logo_landing_light.png"
          style="max-width:100vw;"
        />
        <h1>simple and clean task checklist per day</h1>

        <div style="padding-top: 20px;">
          <a-button v-if="!userLoggedIn" type="primary" @click="authModalVisible=true;">Get started</a-button>
          <a-button v-if="userLoggedIn" type="primary" @click="$router.push({name: 'planner'});">Get started</a-button>

        </div>


        <h2 style="margin-top: 100px;">Planner</h2>        

        <p>You are looking for a lightweight tool to plan your week?</p>
        <p>The planner features checklists in a calendar layout.</p>

        <img 
          class="logo" 
          src="@/assets/screenshot.png"
          style="margin: 20px; max-width:80vw; border: 1px solid #001529;" 
        />

        <h2 style="margin-top: 80px;">Boards</h2>

        <p>Boards are here to help you with your date independent checklists.</p>
        <p>Here you can freely add as many rows of lists as you like.</p>

        <img 
          class="logo" 
          src="@/assets/screenshot_board.png"
          style="margin: 20px; margin-bottom: 80px; max-width:80vw; border: 1px solid #001529;" 
        />

      </a-layout-content>

      <a-layout-footer style="text-align: center">
        <span class="footer">
          <a @click="aboutModalVisible=true;">About</a>
          <a href="https://twitter.com/thisweekrocks" target="_blank">News</a>
          <a href="/terms" target="_blank">Terms</a>
          <a href="/privacy" target="_blank">Privacy</a>
          <a href="https://twitter.com/thisweekrocks" target="_blank">Contact</a>
          <span>©2021 THISWEEK</span>
        </span>
      </a-layout-footer>

    </a-layout>

  <cookie-law theme="dark-lime"></cookie-law>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import firebase from 'firebase/app';
import 'firebase/auth';
import SignUp from '@/auth/SignUp';
import Login from '@/auth/Login';
import About from '@/views/extra/About';

export default {
  name: 'home',
  components: {
    CookieLaw,
    SignUp,
    Login,
    About,
  },  
  data() {
    return {
      userLoggedIn: null,
      authModalVisible: false,
      aboutModalVisible: false,
    }
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {

      if (user) {
        this.userLoggedIn = true;
      } else {
        this.userLoggedIn = false;
      }
    })
  },
  methods: {
    openNotification(title, text) {
      this.$notification.open({
        message: title,
        description: text,
      });
    },
  }
}
</script>

<style scoped>

  .content {
    text-align: center;
  }

  .footer {
    float: right;
  }

  .footer * {
    padding-left: 15px;
  }

</style>

